'use strict';
// Globals
var sourceImageData;

var canvas = null;
var context = null;

var consoleDebug = false;
var debugDiv = null;

exports.analyzeImage= function (pixels, options, callback) { // Parametres AABB, number of digits, config of filters // TBD remove AABB
	canvas = null;
	context = null;
	if (consoleDebug) var startTime = new Date().getTime();
  var digits = options.digits.positions;
  if (!pixels || !digits) return false;

	var config = {
    LUMINANCETHRESHOLD : 40, // Luminance threshold
    localContrastW : 20, // Width of local contrast area
	localContrastMargin : 0.09,
    minimumSize : 40, // Minimum outline pixel count
    maximumSize :  400, // Maximum outline pixel count
    densityLimitForClearing : 0.9, // Maximum AABB area density to clear when searching for objects (improves speed but too low value risks clearing numbers with borders)
    minimumHeight : 25, // Minimum digit height
    maxDensity : 0.8, // Max digit density for numbers other than 1
    AABBRatioForDigit1 : 2.0, // Lowest AABB ratio for digit 1
    AABBverticalRatioMin : 1, // Minimum vertical ratio for digit area
    AABBverticalRatioMax : 8, // Maximum vertical ratio for digit area
    digitHeight : options.digits.height || 0,
    invert : false // invert image (if black background on digits)
  }

	var width = 640;
	var height = 480;
	var channels = 4;
	var data;

	// Pixel data received - fetch some measurements
	if (pixels.shape) {
		width = pixels.shape[0];
		height = pixels.shape[1];
	}
	var floor = Math.floor;

	var img_area = [];
	img_area[0] = digits[0].coords[0] - 8;
	img_area[1] = digits[0].coords[1] - 8;
	img_area[2] = digits[digits.length - 1].coords[2] - img_area[0] + 8;
	img_area[3] = digits[0].coords[3] - img_area[1] + 8;

	if (typeof document === 'object' && !canvas) {
		canvas = document.createElement('canvas');
		canvas.width  = width;
		canvas.height = height;
		context = canvas.getContext("2d");
		sourceImageData = context.createImageData(width, height);
		data = sourceImageData.data;
		// copy pixels to ImgData
		for (var i = 0, len = width * height * channels; i < len; i++) {
    		data[i] = pixels.data[i];
		}
		// draw original source to canvas
		context.putImageData(sourceImageData, 0, 0);
	} else data = pixels.data;
	/*
	if (consoleDebug) {
		console.log("Time after luminance: " + (new Date().getTime() - startTime));
	}
	*/
	//separateRed(LUMINANCETHRESHOLD, width, channels);
	for (var i = 0; i < digits.length; i++){
		var digit = digits[i];
		var A = [];
		A[0] = digit.coords[0] - 1;	A[1] = digit.coords[1] - 1;	A[2] = digit.coords[2] + 1;	A[3] = digit.coords[3] + 1;
		var lW = 1;
		if (digit.coords[3] - digit.coords[1] > 60) lW = 2;
		//if (context) context.putImageData(sourceImageData, 0, 0, img_area[0], img_area[1], img_area[2], img_area[3]);
		var kernelSize = (lW>1)?5:7;
		kuwaharaFilter(data, A, width, height, channels, kernelSize);		
		//localContrastNormalization(config.localContrastW, data, A, config.LUMINANCETHRESHOLD, width, channels);
		localContrastNormalization(config.invert, config.localContrastW, data, A, config.localContrastMargin, width, channels);
		var digitObjects = [];
		var eliminatedPixels = [];
		// Clear areas that are wrong shape and size
		var tripleCheck = false;
		if (lW > 1) {
			findObjects(9, 1600, 22, digit.coords, data, digitObjects, width, channels, eliminatedPixels);
			tripleCheck = true;
		}
		var padding = 4;
		fillHoles([A[0] + padding, A[1] + padding, A[2] - padding, A[3] - padding], data, width, channels);
		//if (config.invert) invertData(data, A, width, channels);
		if (context) drawDigitCoords(digit.coords);
		// Clear arrays
		if (context) context.putImageData(sourceImageData, 0, 0, img_area[0], img_area[1], img_area[2], img_area[3]);
		var fullH = digit.coords[3] - digit.coords[1];
		var halfH = Math.round(fullH / 2);
		
		var verBars = getVerticalCrossings({w : digit.coords[2] - digit.coords[0], h : fullH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, 0);
		if (tripleCheck) {
			var verBars2 = getVerticalCrossings({w : digit.coords[2] - digit.coords[0], h : fullH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, -6);
			var verBars3 = getVerticalCrossings({w : digit.coords[2] - digit.coords[0], h : fullH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, 6);
			if (verBars.length != verBars2.length || verBars.length != verBars3.length) {
				digit.result = -1;
				if (consoleDebug) {
					console.log("Digit : " + result);
				}
				continue;
			}
		}
				
		var horTopBars = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, 0);
		if (tripleCheck) {
			var horTopBars2 = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, -7);
			var horTopBars3 = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1]}, data, width, channels, lW, 7);
			if (horTopBars.length != horTopBars2.length || horTopBars.length != horTopBars3.length) {
				digit.result = -1;
				if (consoleDebug) {
					console.log("Digit : " + result);
				}
				continue;
			}
			if (horTopBars.length == 2)	{ // Check that the crossing are at similar positions
				if (Math.abs(horTopBars2[0] - horTopBars3[0]) > .025) {
					digit.result = -1;
					if (consoleDebug) {
						console.log("Digit : " + result);
					}
					continue;
				}				
				
			}
			
			
		}
		
		var horBottomBars = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1] + halfH}, data, width, channels, lW, 0);
		if (tripleCheck) {
			var horBottomBars2 = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1] + halfH}, data, width, channels, lW, -7);
			var horBottomBars3 = getHorizontalCrossings({w : digit.coords[2] - digit.coords[0], h : halfH, x : digit.coords[0], y : digit.coords[1] + halfH}, data, width, channels, lW, 7);
			if (horBottomBars.length != horBottomBars2.length || horBottomBars.length != horBottomBars3.length) {
				digit.result = -1;
				if (consoleDebug) {
					console.log("Digit : " + result);
				}
				continue;
			}
		}
		if (consoleDebug) {
			console.log("Ver : " + verBars.length + " Hor1 : " + horTopBars.length + " Hor2 : " + horBottomBars.length);
		}

		var bars = createBarMatrix(verBars, horTopBars, horBottomBars);
		var result = detectDigit(bars);
		digit.result = result;
		if (consoleDebug) {
			console.log("Digit : " + result);
		}
	}

	/*
	var w = object.w;
	var h = object.h;
	var x = object.AABB[0];
	var y = object.AABB[1];
	*/

	//if (context) context.putImageData(sourceImageData, 0, 0, img_area[0], img_area[1], img_area[2], img_area[3]);
	/*
	if (consoleDebug) {
		console.log("Time : " + (new Date().getTime() - startTime));
	}
*/
	if (debugDiv && canvas) {
		debugDiv.appendChild(canvas);
	}

	var minH = 0, maxH = 0;
	for (var j = 0; j < digits.length; j++) {
		if (digits[j].digitHeight) {
			if (minH === 0) { minH = digits[j].digitHeight;}
			if (minH > digits[j].digitHeight) { minH = digits[j].digitHeight;}
			if (maxH === 0) { maxH = digits[j].digitHeight;}
			if (maxH < digits[j].digitHeight) { maxH = digits[j].digitHeight;}
		}
	}
	var h = Math.floor((minH + maxH) / 2);
	//console.log("h:", h);
	//console.log("minH:", minH);
	//console.log("maxH:", maxH);
	//var h = (digitObjects[0]) ? digitObjects[0].h + 2 : 0;
	
		if (!callback) return { digits: digits, canvas: canvas, height: h};
	setTimeout(function() {
		callback(null, { digits: digits, canvas: canvas, height: h});
	},1)
	
}


function findObjects(minSize, maxSize, minEdge, selectedArea, data, digitObjects, W, CH, eliminated){
	var middle = selectedArea[1] + ((selectedArea[3] - selectedArea[1]) >> 1);
	var middleX = selectedArea[0] + ((selectedArea[2] - selectedArea[0]) >> 1);
	var scale = (selectedArea[3] - selectedArea[1]) / 85;
	for (var j = selectedArea[1], digitObject = null; j <= selectedArea[3]; j++){ // lines - start from top
		for (var i = selectedArea[0], index, object, oL, w, h, AABB, AABB1, AABB2, AABB3, AABBRatio, pixelDensity, center; i < selectedArea[2]; i++){ // rows
			index = i * CH + j * CH * W; // Position to index
			if (eliminated[index]) continue;
			if (data[index] > 0) {
				// We've found a possible object edge, try to get the outline
				object = getOutlinePixels(index, selectedArea[0], selectedArea[1], selectedArea[2], selectedArea[3], false, data, W, CH);
				// Check if the object passes simple filters
				if (!object) continue;
				oL = object.length;
				if (oL < 4) continue;

				// Get AABB of object - Could we do this already during getOutlinePixels?
				var minX = 9999, maxX = 0, minY = 9999, maxY = 0; // Normal AABB
				for (var i2 = 0, pt, x, y; i2 < oL; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}

				AABB = [minX, minY, maxX, maxY];
				w = AABB[2] - AABB[0];
				h = AABB[3] - AABB[1];
				AABBRatio = h / w;
				// Remove object if it touches the edges
				if (Math.abs(minX - selectedArea[0]) < 1) {
					if (consoleDebug) console.log("Eliminating");
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				
				if (Math.abs(maxX - selectedArea[2]) < 1) {
					if (consoleDebug) console.log("Eliminating");
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				
				if (Math.abs(minY - selectedArea[1]) < 1) {
					if (consoleDebug) console.log("Eliminating");
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				if (Math.abs(maxY - selectedArea[3]) < 1) {
					if (consoleDebug) console.log("Eliminating");
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}

				
				if (oL < minSize) {
					//if (consoleDebug) console.log("Eliminating");
					//eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				if (oL > maxSize) {
					continue;
				}
				
				center = {x: AABB[0] + (w >> 1), y: AABB[1] + (h >> 1)};
								
				if (minX > middleX - 15 * scale && maxX < middleX + 15 * scale && minY > middle - 30 * scale && maxY < middle + 30 * scale) {
					if (!(h > 8 * scale && h < 13 * scale && Math.abs(center.y - middle) < 4 * scale)) {
						if (consoleDebug) console.log("Eliminating");
						eliminateObjectArea(object, false, W, CH, eliminated, data);
						continue;
					}
				}
				
				
				// Remove object if it's too small and doesn't seem to be part of the edge
				/*
				if (h < minEdge && w < minEdge) {
					if (!(w > 8 && w < 13) && !(h > 8 && h < 13)) {
						if (consoleDebug) console.log("Eliminating");
						eliminateObjectArea(object, false, W, CH, eliminated, data);
						continue;
					}
				} */
				
				
				if (h > 15 * scale && w < 25 * scale && Math.abs(center.x - middleX) < 10 * scale) {
					if (consoleDebug) console.log("Eliminating");
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
								// AABB sections
				var minX1 = 9999, maxX1 = 0, minY1 = 9999, maxY1 = 0;
				var minX2 = 9999, maxX2 = 0, minY2 = 9999, maxY2 = 0;
				var minX3 = 9999, maxX3 = 0, minY3 = 9999, maxY3 = 0;
				var section1Limit = Math.floor(maxY - minY / 3);
				var section2Limit = section1Limit * 2;
				for (var i2 = 0, pt, x, y; i2 < oL; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (y <= section1Limit){
						if (x < minX1) minX1 = x;
						if (x > maxX1) maxX1 = x;
						if (y < minY1) minY1 = y;
						if (y > maxY1) maxY1 = y;
					} else if (y > section2Limit){
						if (x < minX3) minX3 = x;
						if (x > maxX3) maxX3 = x;
						if (y < minY3) minY3 = y;
						if (y > maxY3) maxY3 = y;
					} else {
						if (x < minX2) minX2 = x;
						if (x > maxX2) maxX2 = x;
						if (y < minY2) minY2 = y;
						if (y > maxY2) maxY2 = y;
					}
				}
				AABB1 = [minX1, minY1, maxX1, maxY1];
				AABB2 = [minX1, minY1, maxX1, maxY1];
				AABB3 = [minX1, minY1, maxX1, maxY1];
				//if (context) drawOutline2(object, AABB[0], AABB[1], 300, 0);
				//if (smoothing) smoothOutline(object);
				//if (context) drawOutline2(object, AABB[0], AABB[1], 500, 0);
				//if (!digitObject || (digitObject && digitObject.edgePoints < oL)) { // Choose the largest object visible
				digitObject = {id: index, value: 1, center: center, edgePoints: oL, AABB: AABB, AABB1: AABB1, AABB2: AABB2, AABB3: AABB3, points : object, w: w, h: h};
				//}

				
				
				
				if (w < 20 * scale && h < minEdge * scale && h > 12 * scale && getEdgeVariance(digitObject, 1, digitObject.h - 1, false) > 6 * scale) {
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				
				

				// Validate that AABB has correct dimensions
				/*
				if (AABBverticalRatioMin) {
					if (AABBRatio < AABBverticalRatioMin) {
						eliminateObjectArea(object, false, W, CH, eliminated);
						continue;
					}
				}

				if (AABBverticalRatioMax) {
					if (AABBRatio > AABBverticalRatioMax) {
						eliminateObjectArea(object, false, W, CH, eliminated);
						continue;
					}
				} 
				if (h < (selectedArea[3] - selectedArea[1]) * .4) { // .6 is good if height not set
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue; // Minimum height is x% of area height
				}*/
				
				/*
				if (!heightSet && Math.abs(middle - center.y) > thresholdForC) {
					if (consoleDebug) console.log("not close enough to center");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				}*/
				// Use percentage to decide if close enough to center
				/*
				if (Math.abs(middle - center.y) / (selectedArea[3] - selectedArea[1]) > .2) {
					if (consoleDebug) console.log("not close enough to center");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				}
				if (middleX - center.x > 4) {
					if (consoleDebug) console.log("Object too much to the left");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				} */


				/*var simpleOutline = poly_simplify(getPixelBuffer(object), 1.2); 
				simpleOutline = getCompressedBuffer(simpleOutline);
				
				if (context) drawOutline3(simpleOutline, AABB[0], AABB[1], 500, 300);
				*/
				//return; // Exit early cause we really only need one suitable object

			}
		}
	}
	if (digitObject) digitObjects.push(digitObject);
}


function getOutlinePixels(p, minX, minY, maxX, maxY, inverted, data, W, CH){
	var max = 9000; // To avoid endless loop
	var maxCounter = 0;
	var outline = [];
	var firstP = p;
	var x = p / CH % W;
	var y =  p / CH / W | 0;
	outline.push(x << 16 | y); // We already got the first pixel
	var backtrack = 7; // Assumed backtrack direction - left
	var neighbors = [];
	var nIndex;
	var counter;
	while (1) {
		maxCounter ++;
		neighbors[0] = p - CH - CH * W;
		neighbors[1] = p - CH * W;
		neighbors[2] = p + CH - CH * W;
		neighbors[3] = p + CH;
		neighbors[4] = p + CH + CH * W;
		neighbors[5] = p + CH * W;
		neighbors[6] = p - CH + CH * W;
		neighbors[7] = p - CH;

		nIndex = backtrack + 1;
		if (nIndex > 7) nIndex = 0;
		counter = 0;
		while (counter < 8) {
			if((!inverted && data[neighbors[nIndex]] > 0) || (inverted && data[neighbors[nIndex]] == 0)) {
				p = neighbors[nIndex];
				x = p / CH % W;
				y = p / CH / W | 0;
				if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
					outline.push(x << 16 | y);
					if (nIndex < 4) backtrack = nIndex + 4; else backtrack = nIndex - 4;
					break;
				}
			}
			nIndex ++;
			counter ++;
			if (nIndex > 7) nIndex = 0;
		}
		if (counter > 7) break; // Exit if no matches found
		if (p == firstP) break; // Exit when first pixel reached again
		if (maxCounter > max) break; // We need to give up to avoid endless loop
	}
	return outline;
}


function getWidthAtY(object, y){
	var widths = getWidthBuffer(object);
	if (y < widths.length) return widths[y];
	else return -1;
}

function getWidthVariance(object, y1, y2){
	var widths = getWidthBuffer(object);
	widths = widths.slice(y1, y2);
	widths.sort(function(a, b){ // Sorts points based on width
		return a - b;
	});
	return Math.abs(widths[0] - widths[widths.length - 1]);
}

function getEdgeVariance(object, y1, y2, right){
	var pts = getEdgeBuffer(object);
	pts = pts.slice(y1, y2);
	var v = 0;
	if (right) { // Sorts points based on x
		pts.sort(function(a, b){ 
			return a[1] - b[1];
		});
		v = Math.abs(pts[0][1] - pts[pts.length - 1][1]);
	} else {
		pts.sort(function(a, b){
			return a[0] - b[0];
		});
		v = Math.abs(pts[0][0] - pts[pts.length - 1][0]);
	}
	
	return v;
}

function getWidthBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var widthBuffer = [];
	var currentY = currentY = pts[0] & 0xffff;
	var lastY = pts[l - 1] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, point, width, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (y > currentY || i == l - 1) {
			width = maxX - minX;
			widthBuffer.push(width);
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	return widthBuffer;
}

function getEdgeBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var buffer = [];
	var currentY = currentY = pts[0] & 0xffff;
	var lastY = pts[l - 1] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, point, width, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (y > currentY || i == l - 1) {
			buffer.push([minX, maxX]);
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	return buffer;
}


function getHeightAtX(object, x){
	var heights = getHeightBuffer(object);
	if (x < heights.length) return heights[x];
	else return -1;
}

function getHeightBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on x
	pts.sort(function(a, b){ // Sorts points from left to right
			var x1 = a >> 16, x2 = b >> 16;
			return x1 - x2;
		});
	var heightBuffer = [];
	var currentX = pts[0] >> 16;
	var lastX = pts[l - 1] >> 16;
	var maxY = 0;
	var	minY = 9999999;
	for (var i = 0, point, height, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (x > currentX || i == l - 1) {
			height = maxY - minY;
			heightBuffer.push(height);
			currentX = x;
			maxY = 0;
			minY = 9999999;
		}
		if (y < minY) minY = y;
		if (y > maxY) maxY = y;
	}
	return heightBuffer;
}



function eliminateObjectArea(pts, inverted, W, CH, eliminated, data){
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var currentY = pts[0] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, w, x, y, pt; i < l; i++) {
		pt = pts[i];
		x = pt >> 16;
		y = pt & 0xffff;
		if (y > currentY) {
			w = maxX - minX;
			for (var j = 0, pi; j <= w; j++) {
				pi = (minX + j) * CH + currentY * CH * W;
				data[pi] = 0;
				data[pi+1] = 255;
				eliminated[pi] = true;
				//if (!inverted) eliminatedPixels.push(pi);
				//else eliminatedInvertedPixels.push(pi);
			}
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	// Last line
	var w = maxX - minX;
	for (var j = 0, pi; j <= w; j++) {
			pi = (minX + j) * CH + y * CH * W;
			data[pi] = 0;
			data[pi+1] = 255;
			eliminated[pi] = true;
			//if (!inverted) eliminatedPixels.push(pi);
			//else eliminatedInvertedPixels.push(pi);
	}
}

// TODO calculate width for every y function - use this to check for top heaviness etc, draw the output for all letters to check for good differences


function getVerticalCrossings(object, data, W, CH, lineWidth, offset){
	var w = object.w;
	var h = object.h;
	var x = object.x;
	var y = object.y;
	var positions = []; // Array containing crossing positions relative to area height
	if (consoleDebug) console.log("getVerticalCrossings call " + " " + x + " " + y + " " + w + " " + h);
	var crossings = 0;
	var counter = 0;
	var counter2 = 0;
	//var lineWidth = 1; // Ignores lines narrower than 3 pixels
	var center = Math.round(x + w / 2);
	var flag = false;
	for (var i = y, index; i <= y + h; i++) {
		index = (center + offset) * CH + i * CH * W;

		if (data[index] > 0 && flag == false) {
			crossings ++;
			var pos = (i - y) / h;
			positions.push(pos);
			flag = true;
			counter = lineWidth;
			counter2 = 0;
		} else if(data[index] == 0) {
			counter2 ++;
			if (counter2 > 1) {
				flag = false;
				if (counter!= 0) {
					counter = 0;
					crossings --;
					positions.pop();
				} else if (counter > 0) counter--;
			}
		}
		else if (counter != 0) {
			counter--;
			counter2 = 0;
		}
	}
	if (counter != 0) {
		crossings --;
		positions.pop();
	}
	return positions;
	//return crossings;
}

function getHorizontalCrossings(object, data, W, CH, lineWidth, offset){
	var w = object.w;
	var h = object.h;
	var x = object.x;
	var y = object.y;
	var positions = [];
	var crossings = 0;
	var counter = 0;
	var counter2 = 0;
	//var lineWidth = 1; // Ignores lines narrower than 3 pixels
	var center = y + (h >> 1);
	var flag = false;
	for (var i = x, index; i <= x + w; i++) {
		index = i * CH + (center + offset) * CH * W;
		if (data[index] > 0 && flag == false) {
			crossings++;
			var pos = (i - x) / w;
			positions.push(pos);
			flag = true;
			counter = lineWidth;
			counter2 = 0;
		} else if(data[index] == 0) {
			counter2 ++;
			if (counter2 > 1) {
				flag = false;
				if (counter!= 0) {
					counter = 0;
					crossings --;
					positions.pop();
				} else if (counter > 0) counter --;
			}
		}
		else if (counter != 0) {
			counter--;
			counter2 = 0;
		}
	}
	if (counter != 0) {
		crossings --;
		positions.pop();
	}
	return positions;
	//return crossings;
}


function createBarMatrix(ver, hor1, hor2){
	var verL = ver.length;
	var hor1L = hor1.length;
	var hor2L = hor2.length;
	if (verL > 3 || hor1L > 2 || hor2L > 2) return null; // Too many crossings found
	//var bars = [0, 0, 0, 0, 0, 0, 0]; // Bar matrix
	
	if (hor1L == 1 && hor2L == 1) {
		if (hor1[0] > .5 && hor2[0] > .5 && Math.abs(hor1[0] - hor2[0]) > .1) return null; // bars not aligned
		if (hor1[0] < .5 && hor2[0] < .5 && Math.abs(hor1[0] - hor2[0]) > .1) return null; // bars not aligned
	}
	if (hor1L == 2 && hor2L == 2 ) {
		if (Math.abs(hor1[1] - hor2[1]) > .1) return null; // bars not aligned
		if (Math.abs(hor1[0] - hor2[0]) > .1) return null; // bars not aligned
	}
	if (hor1L == 2 && hor2L == 1) if (hor2[0] > .5 && Math.abs(hor1[1] - hor2[0]) > .1) return null; // bars not aligned
	if (hor1L == 1 && hor2L == 2)if (hor1[0] > .5 && Math.abs(hor1[0] - hor2[1]) > .1) return null; // bars not aligned
	if (hor1L == 2 && hor2L == 1)if (hor2[0] < .5 && Math.abs(hor1[0] - hor2[0]) > .1) return null; // bars not aligned
	if (hor1L == 1 && hor2L == 2)if (hor1[0] < .5 && Math.abs(hor1[0] - hor2[0]) > .1) return null; // bars not aligned
	
	
	var bars = 0;
	if (verL == 1) {
		if (ver[0] < 0.25) bars |= 1; // bars[0] = 1;
		if (ver[0] > 0.25 && ver[0] < 0.75) bars |= 1 << 1; // bars[1] = 1;
		if (ver[0] > 0.75) bars |= 1 << 2; // bars[2] = 1;
	}
	if (verL == 2) {
		if (ver[0] < 0.25) bars |= 1; // bars[0] = 1;
		if ((ver[0] > 0.25 && ver[0] < 0.75) || (ver[1] > 0.25 && ver[1] < 0.75)) bars |= 1 << 1; // bars[1] = 1;
		if (ver[1] > 0.75) bars |= 1 << 2; // bars[2] = 1;
	}
	if (verL == 3) {
		if (ver[0] < 0.25) bars |= 1; // bars[0] = 1;
		if (ver[1] > 0.25 && ver[1] < 0.75) bars |= 1 << 1; // bars[1] = 1;
		if (ver[2] > 0.75) bars |= 1 << 2; // bars[2] = 1;
	}
	if (hor1L == 1) {
		if (hor1[0] < 0.35) bars |= 1 << 3; // bars[3] = 1;
		if (hor1[0] > 0.65) bars |= 1 << 4; // bars[4] = 1;
	}
	if (hor1L == 2) {
		if (hor1[0] < 0.35) bars |= 1 << 3; // bars[3] = 1;
		if (hor1[1] > 0.65) bars |= 1 << 4; // bars[4] = 1;
	}
	if (hor2L == 1) {
		if (hor2[0] < 0.35) bars |= 1 << 5; // bars[5] = 1;
		if (hor2[0] > 0.65) bars |= 1 << 6; // bars[6] = 1;
	}
	if (hor2L == 2) {
		if (hor2[0] < 0.35) bars |= 1 << 5; // bars[5] = 1;
		if (hor2[1] > 0.65) bars |= 1 << 6; // bars[6] = 1;
	}
	return bars;
}

function detectDigit(bars){
	if (bars == 125) return 0;
	if (bars == 80) return 1;
	if (bars == 55) return 2;
	if (bars == 87) return 3;
	if (bars == 90) return 4;
	if (bars == 79) return 5;
	if (bars == 111) return 6;
	if (bars == 81) return 7;
	if (bars == 127) return 8;
	if (bars == 95) return 9;
	return -1;
}

// MORE HELPER FUNCTIONS

function localContrastNormalization(invert, size, data, imgArea, threshold, W, CH){
	var xEnd = imgArea[2],
		yEnd = imgArea[3];
	var divisor = 1 / ((size) * (size) - 1);
	for (var y = imgArea[1]; y <= yEnd; y++){
		for (var x = imgArea[0], neighbors, sum, l, avg, i, x2, y2; x < xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			sum = 0;
			for (var jj = 0; jj < size; jj += 1){ // lines
				for (var ii = 0, x, y, index; ii < size; ii += 1){ // rows
					x2 = x + ii - (size >> 1);
					y2 = y + jj - (size >> 1);
					if (x2 == x && y2 == y) continue; // don't include yourself
					sum += data[x2 * CH + y2 * CH * W + 2];
				}
			}
			avg = sum * divisor;
			if (invert) {
				if (data[i + 2] > avg + avg * threshold) data[i] = 255;
				else data[i] = 0;

			} else {
				if (data[i + 2] < avg - avg * threshold) data[i] = 255;
				else data[i] = 0;
			}
		}
	}
}

function fillHoles(AABB, data, W, CH){ // Fills gaps to prevent leakage problems
	for (var y = AABB[1]+2; y < AABB[3]-2; y++) {
		for (var x = AABB[0]+2; x < AABB[2]-2; x++) {
			var index = x * CH + y * CH * W;
			if (data[index] == 0) {
				if( data[index - 4] == 255 && data[index + 4] == 255) data[index] = 255;
				else if (data[index - 4] == 255 && data[index + 8] == 255) data[index] = 255;
				else if (data[index - 8] == 255 && data[index + 4] == 255) data[index] = 255;
				else if (data[index - CH * W] == 255 && data[index + CH * W] == 255) data[index] = 255;
				else if (data[index - CH * W] == 255 && data[index + CH * W * 2] == 255) data[index] = 255;
				else if (data[index - CH * W * 2] == 255 && data[index + CH * W] == 255) data[index] = 255;
				else if (data[index - CH * W * 2] == 255 && data[index + CH * W * 2] == 255) data[index] = 255;
			}
		}
		
	}
}



function calculateLuminance(data, imgArea, W, CH) { // Use imgArea to limit area
	var floor = Math.floor;
	var xEnd = imgArea[0] + imgArea[2],
		yEnd = imgArea[1] + imgArea[3];
	for (var y = imgArea[1], r, g, b, lum; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x < xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			r = data[i], g = data[++i], b = data[++i];
			data[i] = (r + r + b + g + g + g) / 6 | 0;
		}
	}
}

function invertData(src, imgArea, W, CH) {
	var xEnd = imgArea[0] + imgArea[2],
		yEnd = imgArea[1] + imgArea[3];
	for (var y = imgArea[1]; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x < xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			if (src[i] == 0) src[i] = 255;
			else if (src[i] == 255) src[i] = 0;
		}
    }
}

// DEBUG DRAWING FUNCTIONS

function drawOutline(outline){
	for (var i = 0; i < outline.length; i++){
		context.fillStyle = "white";
		var p = outline[i];
		var x = p >> 16;
		var y = p & 0xffff;
		context.fillRect(x, y, 1, 1);
	}
}

function drawAABBs(objects){
	for (var i = 0; i < objects.length; i ++){
		var pts = objects[i].AABB;
		var w = pts[2] - pts[0];
		var h = pts[3] - pts[1];
		context.lineWidth = 1;
		context.globalAlpha = .9;
		context.strokeStyle = "green";
		context.strokeRect(pts[0], pts[1], w, h);
		context.fillStyle = "blue";
		context.fillRect(objects[i].center.x, objects[i].center.y, 2, 2);
		context.globalAlpha = 1;
	}
}

function drawDigitCoords(coords){
	var w = coords[2] - coords[0];
	var h = coords[3] - coords[1];
	context.lineWidth = 1;
	context.globalAlpha = .9;
	context.strokeStyle = "white";
	context.strokeRect(coords[0], coords[1], w, h);
	context.globalAlpha = 1;
}
/*
function showEliminated(){
	context.fillStyle = "orange";
	for (var i = 0, l = eliminatedPixels.length; i < l; i++) {
		var index = eliminatedPixels[i];
		var x = (index / channels) % width;
		var y =  Math.floor((index / channels) / width);
		context.fillRect(x, y, 1, 1);
	}
}
*/


function kuwaharaFilter(src, imgArea, W, H, CH, kernelSize) {
	var areaW = (kernelSize + 1) / 2;
	var offset = (kernelSize - 1) / 2;
	var xStart = imgArea[0],
	yStart = imgArea[1],
	xEnd = imgArea[2],
	yEnd = imgArea[3];
	if (context) var imgData2 = context.createImageData(xEnd - xStart, yEnd - yStart);
	var buf = [];
		
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var color = src[i];
			// Create corner areas
			var x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			var x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			var y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			var y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance2 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance2[0] < areaVariance[0]) areaVariance = areaVariance2;
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance3 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance3[0] < areaVariance[0]) areaVariance = areaVariance3;
			x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance4 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance4[0] < areaVariance[0]) areaVariance = areaVariance4;
			//src[i] = areaVariance[1]; // Set value to the mean of area with least variance
			var i2 = (x - xStart) * CH + (y - yStart) * CH * (xEnd - xStart); // Position to index
			//var i2 = i; // Position to index
			buf[i] = areaVariance[1]| 0;
			/*
			imgData.data[i] = areaVariance[1]| 0;
			imgData.data[i+1] = areaVariance[1]| 0;
			imgData.data[i+2] = areaVariance[1]| 0;
			imgData.data[i+3] = 255; */
			if (context) {
				imgData2.data[i2] = areaVariance[1]| 0;
				imgData2.data[i2+1] = areaVariance[1]| 0;
				imgData2.data[i2+2] = areaVariance[1]| 0;
				imgData2.data[i2+3] = 255;
			}
			//imgData2.data[i2] = imgData.data[i];
			//imgData2.data[i2+1] = imgData.data[i+1];
			//imgData2.data[i2+2] = imgData.data[i+2] 0;
			//imgData2.data[i2+3] = 255;
		}
    } 
	if (context) context.putImageData(imgData2, 10, 300);
	// Copy buf to image data
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			src[i] = buf[i];
			src[i+1] = buf[i];
			src[i+2] = buf[i];
			src[i+3] = 255;
		}
	}
	//src.set(imgData.data);
}


function getAverage(data){
	var i = data.length, sum = 0;
	while( i-- ){ sum += data[i]; }
	return sum / data.length;
}

function getVariance(data){
	var i = data.length, v = 0;
	if (i < 2) {
		return [9999999999999, 0];
	}
	var avg = getAverage(data);
	while(i--){
		v += Math.pow( (data[ i ] - avg), 2 );
	}
	return [v / data.length, avg];
}


function getAreaData(src, x1, y1, x2, y2, W, CH){
	var data = [];
	for (var y = y1; y <= y2; y++){ // lines
		for (var x = x1, i; x <= x2; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			data.push(src[i]);
		}
	}
	return data;
}





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/digitreader_kamstrup.js
// module id = 841
// module chunks = 0